import { render, staticRenderFns } from "./son1.vue?vue&type=template&id=f6582662&scoped=true"
import script from "./son1.vue?vue&type=script&lang=js"
export * from "./son1.vue?vue&type=script&lang=js"
import style0 from "./son1.vue?vue&type=style&index=0&id=f6582662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6582662",
  null
  
)

export default component.exports